import { PageRender } from "@/components/layout/frontend/page"

/**
 * Page: Kulturrallye
 */
const KulturrallyePage: React.FC = () => {
  return <PageRender pageKey="kulturrallye" />
}
export default KulturrallyePage
